import { render, staticRenderFns } from "./GameDetail.vue?vue&type=template&id=bd5c5a54&scoped=true"
import script from "./GameDetail.vue?vue&type=script&lang=js"
export * from "./GameDetail.vue?vue&type=script&lang=js"
import style0 from "./GameDetail.vue?vue&type=style&index=0&id=bd5c5a54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd5c5a54",
  null
  
)

export default component.exports